import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@metarouter-private/mr-mui';
import buildPipelineIntegrationOptions from './buildPipelineIntegrationOptions';

const STATIC_PROPS = {
  label: 'Integration',
  variant: 'outlined',
  size: 'small',
  'data-test-id': 'pipeline-integrations-select',
};

export default function BasePipelineIntegrationSelect({
  selectedPipelineIntegrationId,
  pipelineIntegrations,
  onChange,
  ...selectProps
}) {
  const options = buildPipelineIntegrationOptions(pipelineIntegrations);
  const value = selectedPipelineIntegrationId ?? '';
  return <Select {...STATIC_PROPS} options={options} value={value} onChange={onChange} {...selectProps} />;
}

BasePipelineIntegrationSelect.propTypes = {
  pipelineIntegrations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      integration: PropTypes.shape({
        starterkitId: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }),
    })
  ).isRequired,
  selectedPipelineIntegrationId: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
